import React from "react";
import { Music, ListMusic, Drum, Music2 } from "lucide-react";

export type SongwriterBlockType =
  | "SONG_NAME"
  | "SONG_TYPE"
  | "SONG_BEAT"
  | "SONG_LYRICS";

export interface SongwriterBlock {
  id: string;
  type: SongwriterBlockType;
  text: string;
  position?: string; // Lexicographical indexing key
}

export const songwriterBlockTypes: SongwriterBlockType[] = [
  "SONG_NAME",
  "SONG_TYPE",
  "SONG_BEAT",
  "SONG_LYRICS",
];

export const songwriterToolbarTypes: SongwriterBlockType[] = [
  "SONG_BEAT",
  "SONG_LYRICS",
];

export const songwriterIcons: Record<SongwriterBlockType, React.ReactNode> = {
  SONG_NAME: React.createElement(Music, {
    className: "w-[18px] h-[18px]",
    strokeWidth: 1.5,
  }),
  SONG_TYPE: React.createElement(ListMusic, {
    className: "w-[18px] h-[18px]",
    strokeWidth: 1.5,
  }),
  SONG_BEAT: React.createElement(Drum, {
    className: "w-[18px] h-[18px]",
    strokeWidth: 1.5,
  }),
  SONG_LYRICS: React.createElement(Music2, {
    className: "w-[18px] h-[18px]",
    strokeWidth: 1.5,
  }),
};

export const songwriterStyles: Record<
  SongwriterBlockType,
  {
    label: string;
    className: string;
    placeholder: string;
    inputStyle: React.CSSProperties;
  }
> = {
  SONG_NAME: {
    label: "Song Name",
    className: "text-indigo-900",
    placeholder: "ENTER SONG TITLE...",
    inputStyle: {
      textTransform: "uppercase",
      fontWeight: 700,
      textAlign: "center",
      letterSpacing: "0.15em",
      fontSize: "1.25rem",
      outline: "none",
      whiteSpace: "pre-wrap",
      overflowWrap: "break-word",
      wordBreak: "break-word",
    },
  },
  SONG_TYPE: {
    label: "Song Type",
    className: "text-indigo-600",
    placeholder: "e.g., POP BALLAD, MELANCHOLIC PIANO SOLO...",
    inputStyle: {
      fontStyle: "italic",
      textAlign: "center",
      outline: "none",
      whiteSpace: "pre-wrap",
      overflowWrap: "break-word",
      wordBreak: "break-word",
    },
  },
  SONG_LYRICS: {
    label: "Lyrics",
    className: "text-zinc-900",
    placeholder: "Type lyrics line here...",
    inputStyle: {
      fontStyle: "italic",
      marginLeft: "0.5in",
      maxWidth: "6in",
      outline: "none",
      whiteSpace: "pre-wrap",
      overflowWrap: "break-word",
      wordBreak: "break-word",
      fontSize: "1.05rem",
      textAlign: "left",
      lineHeight: "15pt",
    },
  },
  SONG_BEAT: {
    label: "Beat Cue",
    className: "text-fuchsia-900",
    placeholder: "[MUSIC BEGINS: ACOUSTIC GUITAR STRUMMING...]",
    inputStyle: {
      textTransform: "uppercase",
      fontWeight: 700,
      textAlign: "right",
      letterSpacing: "0.1em",
      outline: "none",
      whiteSpace: "pre-wrap",
      overflowWrap: "break-word",
      wordBreak: "break-word",
    },
  },
};

export const uuid = (): string => {
  const timestamp = Date.now().toString(36);
  const bytes = new Uint8Array(10);
  crypto.getRandomValues(bytes);
  const random = Array.from(bytes, (b) => b.toString(36).padStart(2, "0")).join(
    "",
  );
  return `${timestamp}${random}`;
};
